module.exports = __webpack_public_path__ + "static/media/Sopes de camaron.bd5afab7.webp";